import { inject } from "vue"



export class InjectionService {

    public static injectStrict<T>(key: string | symbol): T {

        const result = inject<T>(key);
        if (!result) {
            throw new Error(`Injection "${String(key)}" not found`);
        }
        return result;

    }

    // - sync instance provided directly
    // - a Promise provided directly
    // - a factory function that returns T or Promise<T>
    public static async injectAsync<T>(key: string | symbol): Promise<T> {
        const result = inject<any>(key);
        if (!result) throw new Error(`Injection "${String(key)}" not found`);
        // function factory -> call it
        if (typeof result === "function") {
            const v = result();
            return await Promise.resolve(v);
        }
        // promise or value -> resolve
        return await Promise.resolve(result);
    }

}